<template>
    <div class='mvt-factcard card-box flex vertical top p-y-2 p-x-2' v-ga:clickable :data-link-name="subtitle">
        <i :class='`f1 icon-${icon}`'></i>
        <slot></slot>
        <div class='text-bold f6'>{{ subtitle }} <span v-if="info"><i class="icon-Info-Circle" v-tip :tip="info"></i></span></div>
    </div>
</template>
<script src='./mvt-factcard.js'>
</script>